@if (_isLoading == false) {
  <div>
    <h4>We've received your application and given it a unique reference number of {{"Q"+quote_result.CaseReference}}, which we've also e-mailed to you. </h4>
    <p>
      Our expert team will be in touch shortly, in the meantime, if you’d like to speak to us call <a href="tel:+01614513157">0161 768 5337</a>.</p>
      <p><a href="https://togethermoney.com/auction-finance/" target="_blank" title="Visit our website">Visit our website</a> to find out everything from how auction finance works, to handy tips for the big day.
    </p>
  </div>
}
@if (_isLoading == true) {
  <div>
    <h3>Please wait a moment while we load your details..</h3>
  </div>
}
<together-auction-dip-loading [is_loading]="_isLoading"></together-auction-dip-loading>